<template>
  <div style="max-width:600px;margin:0 auto;background:#fff;">
    <div class="header">
      <div class="title">{{activity_name}}</div>
      <div class="sub_title">{{sub_title}}</div>
    </div>
    <div class="content_body" v-if="!success">
      <div class="text">{{description}}</div>
      <el-form ref="model" :rules="models" :model="model">
          <el-form-item style="margin-bottom: 10px;padding:5px 10px;" prop="user_name">
            <div class="options">
              <div class="options_title">学生名字 <span class="option_red">*</span></div>
              <div class="options_text">请填写学生完整名字</div>
              <el-input type="text" class="text_ipt" v-model="model.user_name"></el-input>
            </div>
          </el-form-item>
           <el-form-item style="margin-bottom: 10px;padding:5px 10px;" prop="phone">
              <div class="options">
                <div class="options_title">联系方式 <span class="option_red">*</span></div>
                <div class="options_text">请填写家长手机号码</div>
                <el-input type="text" maxlength="11" class="text_ipt" v-model="model.phone"></el-input>
              </div>
            
          </el-form-item>
           <el-form-item style="margin-bottom: 10px;padding:5px 10px;" prop="school_id">
              <div class="options">
                <div class="options_title">就读学校 <span class="option_red">*</span></div>
                <div class="options_text">请填写学生就读学校</div>
                <el-select class="text_ipt" ref="select" v-model="model.school_id" filterable remote :remote-method="getSchoolList" @change="getGradeList" @hook:mounted="cancalReadOnly" @visible-change="cancalReadOnly">
                    <el-option
                        v-for="(item,index) in schoolList"
                        :key="index"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
              </div>
          </el-form-item>
           <el-form-item style="margin-bottom: 10px;padding:5px 10px;" prop="grade" v-if="model.school_id > 0">
              <div class="options">
                <div class="options_title">所在年级 <span class="option_red">*</span></div>
                <el-radio-group v-model="model.grade">
                  <div class="radioGroupDiv" v-for="(item,index) in gradeList" :key="index" >
                    <el-radio :label="item.key">{{item.text}}</el-radio>
                  </div>
                </el-radio-group>
              </div>
          </el-form-item>
          <el-form-item style="margin-bottom: 10px;padding:5px 10px;" prop="campus_id">
            <div class="options">
              <div class="options_title">附近校区<span style="font-size: 12px;color: #888;">(在读学员请勾选在读校区)</span> <span class="option_red">*</span></div>
              <el-radio-group v-model="model.campus_id">
                <div class="radioGroupDiv" v-for="(item,index) in campusList" :key="index" >
                  <el-radio :label="item.id">{{item.name + '：'+ item.location}}</el-radio>
                </div>
              </el-radio-group>
            </div>
          </el-form-item>
          <!-- 表单问题 -->
          <el-form-item v-for="(item,index) in activity_forms" :key="index" style="margin-bottom: 10px;padding:5px 10px;">
            <div class="options" >
                <div class="options_title">{{item.title}} <span class="option_red">*</span></div>
                <div v-if="item.type == 0">
                  <el-radio-group v-model="item.answer">
                    <div class="radioGroupDiv" v-for="(value,key) in item.options" :key="key" >
                      <el-radio :label="value">{{value}}</el-radio>
                    </div>
                  </el-radio-group>
                </div>
                <div v-if="item.type == 1">
                  <el-checkbox-group v-model="item.answer">
                    <div class="radioGroupDiv" v-for="(value,key) in item.options" :key="key" >
                      <el-checkbox :label="value">{{value}}</el-checkbox>
                    </div>
                  </el-checkbox-group>
                </div>
                <div v-if="item.type == 2">
                  <el-input type="text" v-model="item.answer" class="text_ipt"></el-input>
                </div>
              </div>
          </el-form-item>
      </el-form>
      <div class="submit_div">
        <el-button type="primary" @click="getSubmit" style="width:100%;">提交</el-button>
      </div>
    </div>
    <div class="content_success" v-else>
        <div class="success_box"><span class="el-icon-success"></span></div>
        <div class="success_title">提交成功</div>
        <div class="success_text">我们已收到您的信息</div>
        <div class="success_text">请等待老师与您联系</div>
        <div class="success_btn">
          <el-button type="primary" @click="getBack" style="width:50%;">返回</el-button>
        </div>
    </div>
  </div>
</template>
<style>
  .el-select-dropdown{
    width: 96%!important;
    left: 2% !important;
  }
  .content_body .el-radio{
    display: flex;
    align-items: center;
  }
  .content_body .el-radio__label{
    display: inline-block;
    width: 96%;
    white-space: break-spaces;
    line-height: 24px;
  }
</style>
<script>
import {appointmentform,appointmentformSubmit,weixincampus,weixinschoolgrade,weixinschools} from "@/api/appointment";
export default {
  name: "questionnaire",
  data() {
    return {
      success:false,
      model:{
        user_name:'',
        phone:'',
        school_id:'',
        grade:'',
        campus_id:'',
      },
      models:{
          user_name:[{ required: true, message: '请输入学生姓名', trigger: 'blur' }],
          phone:[{ required: true, message: '请输入联系方式', trigger: 'blur' }],
          school_id:[{ required: true, message: '请选择在读学校', trigger: 'change' }],
          grade:[{ required: true, message: '请选择所在年级', trigger: 'change' }],
          campus_id:[{ required: true, message: '请选择附近校区', trigger: 'change' }],
      },
      id:0,
      activity_forms:[],
      activity_name:'',
      schoolList:[],
      gradeList:[],
      campusList:[],
      description:'',
      sub_title:'',
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getDetail();
  },
  methods: {
    getDetail(){
      let self = this;
      let data = {
        id:self.id
      }
      appointmentform(data).then(response=>{
            if(response.code == 0){
              self.activity_forms = [];
              for(var i = 0;i<response.data.forms.length;i++){
                 self.activity_forms.push({
                    id:response.data.forms[i].id,
                    options:response.data.forms[i].options,
                    title:response.data.forms[i].title,
                    type:response.data.forms[i].type,
                    type_str:response.data.forms[i].type_str,
                    answer:response.data.forms[i].type == 1?[]:'',
                  })
              }
              self.activity_name = response.data.name;
              self.description = response.data.description;
              self.sub_title = response.data.sub_title;
              self.getCampans();
            }else{
              self.$message({
                  type: "error",
                  duration: 2000,
                  message:  response.msg
              });
            }
      })
    },
    getBack(){
      this.success = false;
    },
    handleClose(){
      this.success = false;
      this.model = {
        user_name:'',
        phone:'',
        school_id:'',
        grade:'',
        campus_id:'',
      };
      this.activity_forms = [];
      this.getDetail();
    },
    getSubmit(){
      this.$refs['model'].validate((valid) => {
          if(valid){
            let answer = [];
            if(this.activity_forms.length > 0){
              for(var i = 0;i<this.activity_forms.length;i++){
                if(this.activity_forms[i].answer == '' || this.activity_forms[i].answer.length == 0){
                  this.$message({type: "error",message:'请填写完整'});
                  return false;
                }
                answer.push({
                  id:this.activity_forms[i].id,
                  answer:this.activity_forms[i].answer,
                  type:this.activity_forms[i].type,
                })
              }
            }
            let self = this;
            let data = {
              id:self.id,
              user_name:self.model.user_name,
              phone:self.model.phone,
              school_id:self.model.school_id,
              grade:self.model.grade,
              campus_id:self.model.campus_id,
              answers:answer,
            }
            appointmentformSubmit(data).then(response=>{
                  if(response.code == 0){
                    self.handleClose();
                    self.success = true;
                  }else{
                    self.$message({
                        type: "error",
                        duration: 2000,
                        message:  response.msg
                    });
                  }
            })
          }
      })
    },
    getCampans(){
      let self = this;
      let data = {}
      weixincampus(data).then(response=>{
            if(response.code == 0){
              self.campusList = response.data;
            }else{
              self.$message({
                  type: "error",
                  duration: 2000,
                  message:  response.msg
              });
            }
      })
    },
    cancalReadOnly(value) {
       this.$nextTick(() => {
            if (!value) {
            const { select } = this.$refs;
            const input = select.$el.querySelector(".el-input__inner");
            input.removeAttribute("readonly");
            // this.$refs.select.blur();  根据tip自行判断是否添加
            }
        });
    },
    getSchoolList(query){
      if(query == null || query == ''){
        return false;
      }
      let self = this;
      let data = {
        key:query
      }
      weixinschools(data).then(response=>{
            if(response.code == 0){
              self.schoolList = response.data;
            }else{
              self.$message({
                  type: "error",
                  duration: 2000,
                  message:  response.msg
              });
            }
      })
    },
    getGradeList(val){
      let self = this;
      let data = {
        school_id:val
      }
      weixinschoolgrade(data).then(response=>{
            if(response.code == 0){
              self.gradeList = response.data;
            }else{
              self.$message({
                  type: "error",
                  duration: 2000,
                  message:  response.msg
              });
            }
      })
    },
  }
};
</script>

<style scoped>
  @import "../static/css/questionnaire.css";
</style>
